export const _3gp2MimeTypes = ["audio/3gpp2", "video/3gpp2"];
